import { render, staticRenderFns } from "./ClientOrderList.vue?vue&type=template&id=3277f4e0&"
import script from "./ClientOrderList.vue?vue&type=script&lang=js&"
export * from "./ClientOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports